import { FC } from 'react';

interface LocaleFlagProps {
  src: string;
  alt?: string;
  className?: string;
}

const LocaleFlag: FC<LocaleFlagProps> = ({ src, alt = '', className }) => (
  <img
    src={src}
    alt={alt}
    className={className}
    width={24}
    height={16}
    style={{
      display: 'block',
      flexShrink: 0,
      width: 24,
      height: 16,
      objectFit: 'cover',
      borderRadius: 2,
    }}
  />
);

export default LocaleFlag;
